import { gql } from '@apollo/client';

const DELETE_TAG_MUTATION = gql`
    mutation deleteTag($input: DeleteTagInput!) {
        result: deleteTag(input: $input) {
            affectedRows
        }
    } 
`;

export default DELETE_TAG_MUTATION;
 